export default {
  InspectionStateEnum: {
    /// <summary>
    /// 删除
    /// </summary>
    delete: -1,
    /// <summary>
    /// 任务下发
    /// </summary>
    start: 0,
    /// <summary>
    /// 检查中
    /// </summary>
    inspection: 1,
    /// <summary>
    /// 待审核
    /// </summary>
    audit: 2,
    /// <summary>
    /// 审核通过
    /// </summary>
    approve: 3,
    /// <summary>
    /// 未通过(重新检查)
    /// </summary>
    fail: 4,
    /// <summary>
    /// 完成
    /// </summary>
    finish: 8,
    /// <summary>
    /// 关闭
    /// </summary>
    close: 9,
  },
  InspectionStateCnEnum: {
    '-1': '删除',
    0: '任务下发',
    1: '检查中',
    2: '待审核',
    3: '审核通过',
    4: '未通过(重新检查)',
    8: '完成',
    9: '关闭',
  },
};
